import { createNativeStackNavigator } from '@react-navigation/native-stack'
import React from 'react'

import { NotificationsPage } from 'pages/Notifications'

import { links } from 'utils/constants'

const Stack = createNativeStackNavigator()

export const NotificationsStack = () => {
  return (
    <Stack.Navigator>
      <Stack.Screen
        component={(props: any) => <NotificationsPage withBack={false} {...props} />}
        name={links.NOTIFICATIONS_PAGE}
        options={{
          title: 'Activity',
          headerShown: false,
        }}
      />
    </Stack.Navigator>
  )
}
